'use strict';

angular.module('shiftTraderApp')
  .service('NoteMessagesService', ['UsersStore', 'TagCloudStore', 'saMediaLinkMatchers', function(UsersStore, TagCloudStore, saMediaLinkMatchers) {

    this.toHTML = function(message, linkify) {
      // First, cut out weird spaces and joiners
      message = message
        .replace(/[\u00A0]/g, ' ')
        .replace(/[\u200D]/g, '')


      // Linkify it up!
      if(linkify) {
        message = linkifyStr(message);
      }

      message = message.trim().replace(/\n/g, '<br/>');

      var makeMention = function(type, id, label, token) {
        return '<span class="atwho-inserted" data-atwho-at-query="'+token+label+'" data-atwho-chosen-value="'+label+'"><span class="mention mention-' + type.toLowerCase() + '" data-model-type="'+type+'" data-model-id="'+id+'" data-model-label="'+label+'">'+label+'</span></span>';
      };

      // Next, inject hashtags
      var wrk = $('<span>' + message + '</span>');
      $(wrk).contents().each(function() {
        if(this.nodeType === document.TEXT_NODE) {
          $(this)
            .before(this.nodeValue.replace(/(^|\s)(#[A-z0-9]+)/g, makeMention('Tag', '$1$2', '$1$2', '')))
            .remove();
        }
      });

      message = $(wrk).html();
      
      // Lastly, inject users and positions
      return message
        .replace( /\[(User|Position)-(\d+)\:([^\]]+)\]/g, makeMention('$1', '$2', '$3', '@'))
    };


    this.toString = function(element) {
      var outbuf = $('<span/>').html(element)

      var userPositionHandler = function(el){return "["+$(el).attr('data-model-type')+"-"+$(el).attr('data-model-id')+":"+$(el).attr('data-model-label')+"]"};

      var handlers = {
        Tag: function(el){return $(el).text()},
        User: userPositionHandler,
        Position: userPositionHandler
      };

      var error = function(el) {
        console.error("No handler for model type " + $(el).attr('data-model-type'))
        return $(el).text()
      };

      $(outbuf).find('.mention').each(function(){
        var h = handlers[$(this).attr('data-model-type')] || error
        $(this).before(h(this)).remove()
      });

      return $(outbuf).text()
    }

    this.findMediaLinks = function(unlinkifiedSrc) {

      var finders = saMediaLinkMatchers;
      var links = linkify.find(unlinkifiedSrc.replace(/\s/g, ' '));

      var output = _.map(links, function(match) {
        for (var service in finders) {
          if ('check' in finders[service] && (match.href.search(finders[service].check) == -1)) {
            continue;
          }

          var capture = match.href.match(finders[service].capture);

          if (capture === null || !capture[1]) {
            continue;
          }

          return {
            service_type: service,
            external_id: capture[1],
            url: match.href,
            hash: service + ":" + capture[1]
          };
        }
        return false;
      });

      return _.filter(output, function(e) {return e !== false;});
    }

  }]);
